module.exports = __webpack_public_path__ + "static/media/travel2.25398353.jpg";